import React, { useEffect, useRef } from 'react';
import { useFacebook } from 'react-facebook';

export default function FacebookSignin({ callback, cancel }) {
  const { init } = useFacebook();

  const api = useRef();
  const FB = useRef();
  const mutex = useRef();

  useEffect(() => {
    (async () => {
      if (api.current) return;
      api.current = await init();
      FB.current = await api.current.getFB();

      FB.current.getLoginStatus(async (status) => {
        //if you are not already logged in
        console.log('Status:', status);
        if (status.status === 'unknown') handleFacebookLogin();
      });
    })();
  }, []);

  async function handleFacebookLogin() {
    try {
      if (mutex.current) return;
      mutex.current = true;

      console.log('Attempting facebook login');

      const response = await api.current.login({
        scope: 'email',
      });

      console.log('Response from facebook:', response);

      if (response.status === 'connected') {
        // Don't try to decode the token - use it to fetch user data instead
        const accessToken = response.authResponse.accessToken;

        // Make a request to the Graph API to get user data
        FB.current.api(
          '/me',
          { fields: 'id,name,email,picture' },
          (userData) => {
            console.log('Facebook User Data:', userData);
            // Now you have the user data
            callback({
              ...userData,
              accessToken: accessToken, // Include the access token if needed
            });
          }
        );
      } else if (response.status === 'unknown') {
        cancel(response);
      }
      mutex.current = false;
    } catch (error) {
      console.log('Error in handleFacebookLogin:', error);
      cancel(error.message);
      mutex.current = false;
    }
  }

  return <div>Login via Facebook...</div>;
}
